import React from 'react';
import InsertIdentifiant from 'containers/PasswordRecoveryPages/InsertIdentifiant';
import {
  FORGOT_PASSWORD_LOGIN,
  CHOOSE_METHODS_RECOVERY_PASS,
  FORGOT_PASSWORD_PIN_EMAIL,
  INSERT_NEW_PASSWORD,
  FORGOT_MDP_QUESTION_SCRT,
} from 'containers/PasswordRecoveryPages/constants';
import { CurrentRecoveryStepPropsType } from 'containers/PasswordRecoveryPages/types';
import PasswordRecoveryOptions from 'containers/PasswordRecoveryPages/PasswordRecoveryOptions';
import PinMethodForgotPassword from 'containers/PasswordRecoveryPages/PinMethodForgotPassword';
import QuestionSecretForgotPassword from 'containers/PasswordRecoveryPages/QuestionScrtMethodForgot';
import InsertNewPassword from 'containers/PasswordRecoveryPages/InsertNewPassword';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';
import { EVENT_CATEGORIES } from 'helpers/GATracking';

const CurrentPasswordRecoveryStep = ({
  stepName,
  onSubmitStep,
  isLoading,
}: CurrentRecoveryStepPropsType) => {
  switch (stepName) {
    case FORGOT_PASSWORD_LOGIN:
      return (
        <InsertIdentifiant onSubmitStep={onSubmitStep} isLoading={isLoading} />
      );
    case CHOOSE_METHODS_RECOVERY_PASS:
      return (
        <PasswordRecoveryOptions
          onSubmitStep={onSubmitStep}
          isLoading={isLoading}
        />
      );
    case FORGOT_PASSWORD_PIN_EMAIL:
      return (
        <GaLoadHOC category={EVENT_CATEGORIES.FORGOTTEN_PASSWORD_EMAIL}>
          <PinMethodForgotPassword
            onSubmitStep={onSubmitStep}
            isLoading={isLoading}
          />
        </GaLoadHOC>
      );
    case FORGOT_MDP_QUESTION_SCRT:
      return (
        <GaLoadHOC
          category={EVENT_CATEGORIES.FORGOTTEN_PASSWORD_QUESION_SECRETE}
        >
          <QuestionSecretForgotPassword
            onSubmitStep={onSubmitStep}
            isLoading={isLoading}
          />
        </GaLoadHOC>
      );
    case INSERT_NEW_PASSWORD:
      return (
        <InsertNewPassword onSubmitStep={onSubmitStep} isLoading={isLoading} />
      );

    default:
      return (
        <InsertIdentifiant onSubmitStep={onSubmitStep} isLoading={isLoading} />
      );
  }
};

export default CurrentPasswordRecoveryStep;
